import Cookies from 'js-cookie';

// const expiresIn = 604800
const expiresIn = 7;

export function getCookies(key) {
    return Cookies.get(key);
}

export function setCookies(key, value, time) {
    const timeout = time || expiresIn;
    return Cookies.set(key, value, { expires: timeout });
}

export function removeCookies(key) {
    return Cookies.remove(key);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js